import React, { useState, useRef } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import SimpleReactValidator from "simple-react-validator";
import { handleResponse } from '..';

function Login() {
    const [name, setName] = useState("");
    const [password, setPassword] = useState("");
    const [isSubmit, setIsSubmit] = useState(false);
    const [passError, setPswError] = useState(false);
    const [, forceUpdate] = useState();
    const validator = useRef(new SimpleReactValidator({
        messages: {
            email: 'Please enter a valid username.'
        },
        autoForceUpdate: { forceUpdate }
    }));

    const handleChange = e => {
        setPassword(e.target.value);
        if (pass_reg.test(password)) {
            setPswError(false);
        }
    }

    const handleSubmit = () => {
        if (!validator.current.allValid()) {
            setIsSubmit(false);
            validator.current.showMessages();
            forceUpdate(1);
            return false;
        }
        if (!pass_reg.test(password)) {
            return setPswError(true);
        }
        setIsSubmit(true);
        const request = new Request(`${interfaceConfig.API_URL}/User/Login`, {
            method: 'POST',
            headers: new Headers({ 'Content-Type': 'application/json' }),
            body: JSON.stringify({ userName: name, password })
        });
        fetch(request).then(res => res.json()).then(res => {
            if (res.token) {
                localStorage.setItem('user', JSON.stringify(res));
                window.location.href = `${interfaceConfig.WEB_URL}/register`;
            } else {
                setIsSubmit(false);
            }

        }).catch(err => {
            setIsSubmit(false);
            toast.error("Sign in failed", { position: toast.POSITION.TOP_LEFT });
        })
        // try {
        //     let json = response.json();
        //     console.log(`%c %s`, `font-size:50px; color:aqua;`, `response`, json);
        //     // window.location.href = `${interfaceConfig.WEB_URL}/register`;
        // } catch (error) {
        //     console.log(error);
        //     toast.error("Sign in failed", {
        //         position: toast.POSITION.TOP_LEFT
        //     });
        // }
    }

    return (
        <section className="login_bg">
            <ToastContainer />
            <div className="container">
                <div className="col-md-12">
                    <div className="row">
                        <div className="col-lg-4 col-md-3 col-sm-3 col-xs-12"></div>
                        <div className="col-lg-4 col-md-6 col-sm-6 col-xs-12">
                            <div className="login_block">
                                <div className="login_about">
                                </div>
                                <div className="row">
                                    <div className="col-lg-12 col-sm-12">
                                        <form onSubmit={handleSubmit}>
                                            <div className="form_login">
                                                <div className="form-group">
                                                    <div className="col-md-12 text-center">
                                                        <img src="./../../../images/logo.png" style={{ width: '120px' }} className="center-block" alt="..." />

                                                    </div>
                                                </div>
                                                <div className="form-group">
                                                    <div className="col-md-12 text-center">
                                                        <h3>Sign In</h3>
                                                    </div>
                                                </div>
                                                <div className="form-group">
                                                    <div className="col-sm-12">
                                                        <div className="input-group input-group-lg">
                                                            <div className="input-group-addon">
                                                                <i className="fa fa-user"></i>
                                                            </div>
                                                            <input type="text" onChange={(e) => setName(e.target.value)} name="userName" value={name} className="form-control" placeholder="Username" />
                                                            <a href={void (0)} data-toggle="tooltip" title="Use your email address" ><i className="fa fa-question-circle help_icon"></i></a>
                                                        </div>
                                                        {validator.current.message("Username", name, `required|email`)}
                                                    </div>
                                                </div>
                                                <div className="form-group">
                                                    <div className="col-sm-12">
                                                        <div className="input-group input-group-lg">
                                                            <div className="input-group-addon">
                                                                <i className="fa fa-lock"></i>
                                                            </div>
                                                            <input type="password" name="password" onChange={handleChange} value={password} className="form-control" placeholder="Password" />
                                                            <a href={void (0)} data-toggle="tooltip" title="Use your account password &#013; The password must be at least 8 characters long, contain 1 uppercase letter, 1 lowercase letter, 1 number and 1 special character" ><i className="fa fa-question-circle help_icon"></i></a>
                                                        </div>
                                                        {validator.current.message("Password", password, "required")}
                                                        {passError && password ? <div className='srv-validation-message'>
                                                            Please enter a valid password
                                                        </div> : null}
                                                    </div>
                                                </div>
                                                <div className="form-group">
                                                    <div className="col-md-12">
                                                        <div className="row">
                                                            <div className="col-sm-6">
                                                            </div>
                                                            <div className="col-sm-6">
                                                                <div className="col-xs-6 text-right">
                                                                    <button type="button" onClick={handleSubmit} disabled={isSubmit} className="btn btn-primary  btn-sm">{isSubmit ? 'Please wait...' : 'Login'}</button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="form-group">
                                                    <div className="col-md-12">
                                                        <div className="row">
                                                            <div className="col-md-12">
                                                                <p><a href="/reset">Need help signing in?</a></p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-3 col-sm-3 col-xs-12"></div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Login